import { ChainId } from '@sushiswap/chain'
import { FURO_SUBGRAPH_URL } from '@sushiswap/graph-config'
import { useQuery } from '@tanstack/react-query'

import { getBuiltGraphSDK } from '../../.graphclient'
import { isSupportedChainId } from '../../config'
import { Vesting } from '../Vesting'
import { fetchWithTimeout } from './fetchWithTimeout'
import { queryRebaseDTO } from './useRebaseDTO'

interface UseStream {
  chainId: ChainId
  vestingId: string
  enabled?: boolean
}

export const useVesting = ({ chainId, vestingId, enabled = true }: UseStream) => {
  return useQuery({
    queryKey: ['useVesting', { chainId, vestingId }],
    queryFn: async () => {
      if (!isSupportedChainId(chainId)) return null

      const sdk = getBuiltGraphSDK({
        chainId,
        url: FURO_SUBGRAPH_URL[chainId]
      })

      const data = await fetchWithTimeout(() => sdk.vesting({ id: vestingId }))
      const token = data?.vesting?.token.id
      const rebase = await fetchWithTimeout(() => queryRebaseDTO({ chainId, address: token }))

      return data.vesting && rebase ? new Vesting({ chainId, furo: data.vesting, rebase }) : null
    },
    refetchInterval: 60000,
    enabled,
  })
}
